/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Pro_Feature_1Inputs */

const en_settings_pro_feature_1 = /** @type {(inputs: Settings_Pro_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`500 AI actions/month`)
};

const de_settings_pro_feature_1 = /** @type {(inputs: Settings_Pro_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`500 KI-Aktionen/Monat`)
};

const fr_settings_pro_feature_1 = /** @type {(inputs: Settings_Pro_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`500 actions IA/mois`)
};

const es_settings_pro_feature_1 = /** @type {(inputs: Settings_Pro_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`500 Acciones IA/mes`)
};

const it_settings_pro_feature_1 = /** @type {(inputs: Settings_Pro_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`500 azioni AI/mese`)
};

const nl_settings_pro_feature_1 = /** @type {(inputs: Settings_Pro_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`500 AI-acties/maand`)
};

const pl_settings_pro_feature_1 = /** @type {(inputs: Settings_Pro_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`500 akcji AI/miesiąc`)
};

const fi_settings_pro_feature_1 = /** @type {(inputs: Settings_Pro_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`500 AI-toimet/kuukausi`)
};

const da_settings_pro_feature_1 = /** @type {(inputs: Settings_Pro_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`500 AI-handlinger/måned`)
};

const sv_settings_pro_feature_1 = /** @type {(inputs: Settings_Pro_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`500 AI-aktioner/månad`)
};

/**
* | output |
* | --- |
* | "500 AI actions/month" |
*
* @param {Settings_Pro_Feature_1Inputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const settings_pro_feature_1 = /** @type {((inputs?: Settings_Pro_Feature_1Inputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Pro_Feature_1Inputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_settings_pro_feature_1(inputs)
	if (locale === "fr") return fr_settings_pro_feature_1(inputs)
	if (locale === "es") return es_settings_pro_feature_1(inputs)
	if (locale === "it") return it_settings_pro_feature_1(inputs)
	if (locale === "nl") return nl_settings_pro_feature_1(inputs)
	if (locale === "pl") return pl_settings_pro_feature_1(inputs)
	if (locale === "fi") return fi_settings_pro_feature_1(inputs)
	if (locale === "da") return da_settings_pro_feature_1(inputs)
	if (locale === "sv") return sv_settings_pro_feature_1(inputs)
	return en_settings_pro_feature_1(inputs)
});